<template>
  <div class="legend">
    <h3>Legend</h3>
    <ul>
      <li>V ➞ visited</li>
      <li>U ➞ upcoming</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Legend',
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.legend {
  position: fixed;
  bottom: 40px;
  left: 40px;
  width: 120px;

  @include mq(sm) {
    left: 90px;
    // bottom: 47px;
    bottom: 78px;
  }

  h3 {
    font-size: 1rem;
    font-weight: normal;
    margin: 0;

    transition: all .45s ease;
    transform: translateY(-15px);

    @include mq(md) {
      font-size: .875rem;
      transform: translateY(0);
    }
  }

  ul {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0;
    margin: 0;

    opacity: 0;
    transform: translateY(5px) scale(0.8);
    transition: all .3s ease;

    @include mq(md) {
      font-size: .875rem;
    }
  }

  &:hover {
    h3 {
      opacity: 0;
      transform: translateY(-35px) scale(0.8);
      transition: all .3s ease;

      @include mq(md) {
        transform: translateY(-20px);
      }
    }

    ul {
      opacity: 1;
      transform: translateY(-27px) scale(1);
      transition: all .45s ease;

      @include mq(md) {
        transform: translateY(-17px) scale(1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterLegend.vue